import axios from "axios";
import dayjs from "dayjs";
import {
  HEADERS_EXPORT_BEN,
  POST_PRE_INVESTIGATE_CHECK,
} from "../../../API/apiUrls";
//from "../../API/apiUrls";
async function dataPostPre({ inDate, textDay, textType }) {
  //console.log("inputDate", inDate,textDay,textType);
  try {
    const res = await axios.post(
      //POST_PRE_INVESTIGATE_CHECK + "120",
      POST_PRE_INVESTIGATE_CHECK + textDay,
      {
        //DATA_TYPE: "vsfhp",
        DATA_TYPE: textType,
        //date: "2025-07-01",
        date: inDate,
      },
      {
        headers: HEADERS_EXPORT_BEN,
      }
    );
    const dataA = res.data;
    //console.log("dataA", dataA);
    const dataB = dataA.filter(
      (item) => item.investigationDate === null || item.wcc.length === 0
    ).map((item) => {
        const newItem = { ...item }; 
          if (item.investigationDate === null) {
            newItem.itemA = 'ยังไม่เคยสืบ';
            newItem.itemAA = 1;
          }else{
           const inDay = dayjs(item.investigationDate);
           const inDayFormat = inDay.format("DD/MM/YYYY");
              switch (item.investigationStatus) {
                case 0:
                  newItem.itemA = `กำลังส่ง วันที่ ${inDayFormat}`;
                  newItem.itemAA = 1;
                  break;
                case 5:
                  newItem.itemA = `รอรับงาน วันที่ ${inDayFormat}`;
                  newItem.itemAA = 1;
                  break;
                case 8:
                  newItem.itemA = `กำลังส่งสืบ วันที่ ${inDayFormat}`;
                  newItem.itemAA = 1;
                  break;
                case 1:
                  newItem.itemA = `เจอทรัพย์ วันที่ ${inDayFormat}`;
                  newItem.itemAA = 20;
                  break;
                case 6:
                  newItem.itemA = `ไม่เจอทรัพย์ วันที่ ${inDayFormat}`;
                  newItem.itemAA = 20;
                  break;
                case 7:
                  newItem.itemA = `เจอทรัพย์ วันที่ ${inDayFormat}`;
                  newItem.itemAA = 20;
                  break;
                default:
                  newItem.itemA = '';
              }
          }
          if (item.wcc.length === 0) {
            newItem.itemB = "ยังไม่บอกเลิก";
          }
          return newItem;
        });
    //console.log("dataB", dataB);
    //setTableSearch(dataB); // ถ้าต้องการแสดงผลใน state
    return dataB; // ✅ แนะนำให้ return ค่าไว้ใช้งานต่อ
  } catch (err) {
    console.log(err.message);
    return []; // แนะนำให้คืนค่ากรณี error เพื่อไม่ให้ caller พัง
  }
}
export default dataPostPre;
